<template>
  <div class="modify-page">
    <navigation
      class="header"
      :showBack="false"
      :theme="{
        background: '#fff',
      }"
    >信息修改
    </navigation>
    <div class="content">
      <div class="divider"></div>
      <img
        src="./images/img_xinxishenhe@2x.png"
        alt=""
      >
      <h2>信息审核中</h2>
      <p>请耐心等待</p>
      <nd-button class="btn" @click="backHome(true)">返回首页</nd-button>
    </div>
    <div class="bottom">
      <span @click="showService=true"> <img src="./images/icon_kefu@2x.png">联系客服</span>
      <p>需要帮助，请联系客服</p>
    </div>

    <service-jw v-model="showService"></service-jw>
  </div>
</template>

<script>
export default {
  components: {
    serviceJw: () => import('@/components/service-jw')
  },
  data () {
    return {
      selected: false,
      isDisabled: true,
      showService: false
    }
  },

  mounted () {
    this.$bus.$emit('ready')
  },

  methods: {
    next () {}
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.modify-page {
  width: 750px;
  min-height: 100vh;
  padding-bottom: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  .header {
    width: 100%;
  }
  .content {
    text-align: center;
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 20px;
    flex: 1;
    width: 750px;

    img {
      width: 162px;
      height: 158px;
      margin-top: 140px;
    }
    h2 {
      font-size: 36px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
    }
    p {
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
    }
    .btn {
      width: 320px;
      height: 80px;
      line-height: 80px;
      border-radius: 40px;
      border: 2px solid #ff4633;
      background: none;
      color: #ff4633;
      margin-top: 30px;
    }
  }
  .divider {
    border-top: 20px solid #f8f8f8;
    height: 0px;
    font-size: 0px;
    width: 100%;
  }
  .bottom {
    padding-bottom: 100px;
    span {
      display: flex;
      align-items: center;
      display: block;
      width: 200px;
      height: 60px;
      line-height: 60px;
      background: #fafafa;
      border-radius: 40px;
      border: 1px solid #eeeeee;
      text-align: center;
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      img {
        width: 29px;
        height: 29px;
        margin-right: 10px;
        vertical-align: -5px;
      }
    }
    p{
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999;
      margin-top: 20px;
    }
  }
}
</style>
